const BoostPackages = {
	pkg1: {
		name: "1 Boost",
		price: 199,
		unitprice: null,
		units: 1,
		type: "BUY_SPOTLIGHT",
		confirm: "You recently boosted your profile across OkCupid.",
	},
	pkg2: {
		name: "5 Boosts",
		price: 945,
		unitprice: 189,
		units: 5,
		type: "BUY_SPOTLIGHT5",
		confirm: "You recently boosted your profile across OkCupid.",
	},

	// An alternate price for pkg2, used by Android:
	pkg2b: {
		name: "5 Boosts",
		price: 899,
		unitprice: 179,
		units: 5,
		type: "BUY_SPOTLIGHT5",
		confirm: "You recently boosted your profile across OkCupid.",
	},
	pkg3: {
		name: "10 Boosts",
		price: 1690,
		unitprice: 169,
		units: 10,
		type: "BUY_SPOTLIGHT10",
		confirm: "You recently boosted your profile across OkCupid.",
	},

	// $0.99 base packages
	pkg4: {
		name: "1 Boost",
		price: 99,
		unitprice: null,
		units: 1,
		type: "BUY_SPOTLIGHT",
		confirm: "You recently boosted your profile across OkCupid.",
	},
	pkg5: {
		name: "5 Boosts",
		price: 399,
		unitprice: 79,
		units: 5,
		type: "BUY_SPOTLIGHT5",
		confirm: "You recently boosted your profile across OkCupi dd.",
	},
	pkg6: {
		name: "10 Boosts",
		price: 799,
		unitprice: 79,
		units: 10,
		type: "BUY_SPOTLIGHT10",
		confirm: "You recently boosted your profile across OkCupid.",
	},
};

export default BoostPackages;



// WEBPACK FOOTER //
// ./src/shared/dictionaries/BoostPackages.js